import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { FieldType, ShComplexListReadonlyFieldComponent } from '@stylehaven/components';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'med-complex-list-readonly-field',
    templateUrl: './complex-list-readonly-field.component.html',
    styleUrls: ['../readonly-base-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComplexListReadonlyFieldComponent extends ShComplexListReadonlyFieldComponent implements OnInit {
    public FieldType: typeof FieldType = FieldType;
    public suggestions$: Observable<string[]>;

    ngOnInit(): void {
        super.ngOnInit();

        this.suggestions$ = combineLatest([this.childDefinition$, this.record$]).pipe(
            map(([definition, record]) =>
                record.metadata.Context?.Suggestions
                    ? record.metadata.Context?.Suggestions.filter(
                          suggestion => suggestion.Structural.FieldDefinition.DottedKey === definition.DottedKey
                      )
                    : []
            ),
            map(suggestions => suggestions.map(suggestion => suggestion.Descriptive.Title))
        );
    }

    protected override initNestedPadding(): void {
        this.nestedPadding$ = this.nestedIndex$.pipe(
            map(index => {
                // Limit the max nesting to prevent UI glitches
                const nesting = Math.min(index, 3);
                return { 'padding-left': `${nesting}rem; width: calc(100% - ${nesting}rem)` };
            })
        );
    }
}
